import React from "react";
import { CategoryApiUrls } from "../../../../../Api/Auth/ApiUrls";
import useSWR from "swr";
import Input from "../../../../../Components/Common/Input";
import Selector from "../../../../../Components/Common/Selector";
import DateInput from "../../../../../Components/Common/DateInput";
import ImageSelector from "../../../../../Components/Common/ImageSelector";

const LiveClassesForm = ({
  onChange,
  handleSubmit,
  errors,
  formData,
  setModalOpen,
  setContentType,
}) => {
  const { isLoading, data } = useSWR(CategoryApiUrls.list);
  const handleDateChange = (name, value) => {
    if (onChange) {
      onChange(name, value?.startDate);
      onChange(name, value?.endDate);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <Input
        label="Title"
        type="text"
        name="title"
        value={formData.title}
        onChange={onChange}
        placeholder="Enter title"
        error={errors.title}
        required
      />
      <Input
        label="Description"
        type="text"
        name="description"
        value={formData.description}
        onChange={onChange}
        placeholder="Enter description"
        error={errors.description}
      />
      <Selector
        name="category"
        label="Category"
        value={formData?.category}
        options={data?.data?.map((item) => ({
          label: item.title,
          value: item._id,
        }))}
        isClearable={false}
        onChange={onChange}
        error={errors?.category}
        isLoading={isLoading}
        required
      />
      <DateInput
        label="Start Date"
        type="text"
        name="startDate"
        value={{
          startDate: formData?.startDate ? formData?.startDate : null,
          endDate: formData?.startDate ? formData?.startDate : null,
        }}
        onChange={handleDateChange}
        placeholder="Enter start date"
        error={errors.startDate}
        required
      />
      <DateInput
        label="End Date"
        type="text"
        name="endDate"
        value={{
          startDate: formData?.endDate ? formData?.endDate : null,
          endDate: formData?.endDate ? formData?.endDate : null,
        }}
        onChange={handleDateChange}
        placeholder="Enter end date"
        error={errors.endDate}
        required
      />
      <Input
        label="Price"
        type="number"
        name="price"
        value={formData.price}
        onChange={onChange}
        placeholder="Enter price"
        error={errors.price}
        required
      />
      <ImageSelector
        label="Upload Image"
        name="image"
        setModalOpen={setModalOpen}
        onChange={onChange}
        value={formData.image}
        placeholder="Click to select an image"
        required
        onClick={() => setContentType("image")}
        error={errors.image}
      />
      <ImageSelector
        label="Upload Routine"
        name="routine"
        setModalOpen={setModalOpen}
        onChange={onChange}
        value={formData.routine}
        placeholder="Click to select routine"
        required
        onClick={() => setContentType("routine")}
        error={errors.routine}
      />
      <Input
        label="Action Button"
        type="text"
        name="actionButton"
        value={formData.actionButton}
        onChange={onChange}
        placeholder="Enter action button text"
        error={errors.actionButton}
      />
    </form>
  );
};

export default LiveClassesForm;
